var _rect, _rect2, _text, _text2, _rect3, _path, _path2, _path3, _circle, _text3, _text4, _rect4, _text5, _text6, _rect5, _circle2, _text7, _rect6, _circle3, _text8, _text9, _rect7, _circle4, _text0, _text1, _rect8, _circle5, _text10, _text11, _rect9, _circle6, _text12, _text13, _text14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreFuelIntelligenceAnomalyDetectionDashboardDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1120,
    height: 610,
    viewBox: "0 0 1120 610",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore desktop fuel intelligence dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1120,
    height: 610,
    rx: 32,
    fill: "#07152A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 1118,
    height: 608,
    rx: 31,
    fill: "none",
    stroke: "#284260",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 49,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    textAnchor: "start",
    letterSpacing: 2
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 38,
    dy: 0
  }, "FUEL INTELLIGENCE"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 92,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 26,
    fontWeight: 830,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 38,
    dy: 0
  }, "Consumption exception \xB7 FC\u20132047"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 126,
    width: 690,
    height: 332,
    rx: 22,
    fill: "#0A213D",
    stroke: "#2A4666"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84 395C158 346 196 366 270 304s126 67 188-28 118 53 224-86",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 326C152 302 210 334 274 284s116 54 184-32 123 31 224-35",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeDasharray: "9 10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84 176V408H690",
    fill: "none",
    stroke: "#3B526D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 276,
    r: 9,
    fill: "#087CFF",
    stroke: "#fff",
    strokeWidth: 3
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 434,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11
  }, "EXPECTED CONSUMPTION")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 690,
    y: 434,
    fill: "#FF8DB8",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11
  }, "OBSERVED CONSUMPTION")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 126,
    width: 328,
    height: 148,
    rx: 22,
    fill: "#0F2847",
    stroke: "#2A4666"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 782,
    y: 164,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800
  }, "VARIANCE FROM EXPECTED")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 782,
    y: 222,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 48,
    fontWeight: 860
  }, "+14.8%")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 947,
    y: 190,
    width: 105,
    height: 34,
    rx: 17,
    fill: "#3A1730"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 968,
    cy: 207,
    r: 5,
    fill: "#FF2775"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 982,
    y: 211,
    fill: "#FF8DB8",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "REVIEW")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 294,
    width: 328,
    height: 52,
    rx: 13,
    fill: "#0A213D",
    stroke: "#2A4666"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 320,
    r: 6,
    fill: "#30D6A1"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 798,
    y: 325,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "Evidence linked")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 1055,
    y: 325,
    fill: "#fff",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "4 / 4")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 360,
    width: 328,
    height: 52,
    rx: 13,
    fill: "#0A213D",
    stroke: "#2A4666"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 386,
    r: 6,
    fill: "#087CFF"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 798,
    y: 391,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "Distance assessed")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 1055,
    y: 391,
    fill: "#fff",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "612 km")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 426,
    width: 328,
    height: 52,
    rx: 13,
    fill: "#0A213D",
    stroke: "#2A4666"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 452,
    r: 6,
    fill: "#FF2775"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 798,
    y: 457,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "Fuel assessed")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 1055,
    y: 457,
    fill: "#fff",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "84.6 L")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 490,
    width: 1044,
    height: 78,
    rx: 17,
    fill: "#091D35",
    stroke: "#2A4666"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 529,
    r: 8,
    fill: "#FF2775"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 523,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 800
  }, "Exception surfaced for review")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 545,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "Evidence remains connected to the original fuel and shift events.")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 1048,
    y: 535,
    fill: "#74BDFF",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800
  }, "OPEN EVIDENCE \u2192")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreFuelIntelligenceAnomalyDetectionDashboardDesktop);
export default __webpack_public_path__ + "static/media/fleetcore-fuel-intelligence-anomaly-detection-dashboard-desktop.21305f1453a372e02f412fed753c257d.svg";
export { ForwardRef as ReactComponent };